import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../features/apiServices/apiClient";
import safeJSON from "../components/safeJSON";
import {
    getSubscriptionStatus,
    isSubscriptionBlocked,
    setSubscriptionStatus,
} from "../features/subscription/subscriptionState";
import "./css/Upgrade.css";

export default function UpgradePage() {
    const [subscription, setSubscription] = useState(null);
    const [blocked, setBlocked] = useState(() =>
        isSubscriptionBlocked(getSubscriptionStatus())
    );
    const activeRestaurant = safeJSON("activeRestaurant");
    const navigate = useNavigate();

    useEffect(() => {
        let alive = true;

        async function loadStatus() {
            if (!activeRestaurant?.id) return;

            try {
                const res = await api.get("/auth/assinatura/status", {
                    headers: {
                        "x-restaurant-id": activeRestaurant.id
                    }
                });

                if (!alive) return;

                setSubscription(res.data);
                setSubscriptionStatus(res.data?.status);
                setBlocked(isSubscriptionBlocked(res.data?.status));
            } catch (err) {
                console.error("Erro ao obter assinatura:", err);
            }
        }

        loadStatus();

        return () => {
            alive = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Pins the blocking screen: Back re-enters this route instead of
    // returning to a cached page of the authenticated area.
    useEffect(() => {
        if (!blocked) return undefined;

        window.history.pushState(null, "", window.location.href);

        const onPopState = () => {
            window.history.pushState(null, "", window.location.href);
        };

        window.addEventListener("popstate", onPopState);
        return () => window.removeEventListener("popstate", onPopState);
    }, [blocked]);

    const handleLogout = useCallback(() => {
        localStorage.clear();
        // replace() leaves the pinned history entry behind.
        window.location.replace("/login");
    }, []);

    return (
        <div className="upgrade-container">

            <div className="upgrade-box">
                {/* LOGO CENTRALIZADO */}
                <div
                    className="upgrade-logo-wrapper"
                    onClick={() => {
                        if (!blocked) navigate("/home");
                    }}
                    style={{ cursor: blocked ? "default" : "pointer" }}
                >
                    <img
                        src="/assets/logo-mesaclick.png"
                        alt="MesaClick Logo"
                        className="upgrade-logo"
                    />
                </div>
                <div className="upgrade-logo-wrapper" >
                    <h1 className="upgrade-title">Ative seu MesaClick Premium</h1>
                </div>


                {blocked && (
                    <p className="upgrade-warning expired">
                        Sua assinatura expirou. Para continuar usando o MesaClick, conclua a ativação abaixo.
                    </p>
                )}

                {subscription?.status === "trial" && (
                    <p className="upgrade-warning trial">
                        Seu teste gratuito termina em <strong>{subscription.trial_days_left} dias</strong>.
                    </p>
                )}

                <p className="upgrade-description">
                    Para ativar sua assinatura do MesaClick, fale com nosso time comercial.
                    O processo é rápido e você recebe o acesso imediatamente após a confirmação.
                </p>

                <div className="plan-cards-container">

                    {/* PLANO MENSAL */}
                    <div className="plan-card">
                        <h3>Plano Mensal</h3>
                        <p className="plan-price">R$ 999,90/mês</p>
                        <ul className="plan-features">
                            <li>✔ Acesso total ao sistema</li>
                            <li>✔ Cozinha KDS</li>
                            <li>✔ Relatórios e Dashboard</li>
                            <li>✔ Mesas ilimitadas</li>
                            <li>✔ Suporte via WhatsApp</li>
                        </ul>

                        <a
                            href="https://wa.me/5567999077564?text=Olá! Quero assinar o PLANO MENSAL do MesaClick."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="plan-btn"
                        >
                            Assinar Mensal
                        </a>
                    </div>

                    {/* PLANO ANUAL */}
                    <div className="plan-card plan-card-annual">
                        <div className="tag-economize">+ ECONÔMICO</div>
                        <h3>Plano Anual</h3>
                        <p className="plan-price">
                            R$ 9.499,00/ano
                            <span className="plan-discount">(~ R$ 791/mês)</span>
                        </p>

                        <ul className="plan-features">
                            <li>✔ 12 meses de acesso</li>
                            <li>✔ Tela KDS completa</li>
                            <li>✔ Relatórios premium</li>
                            <li>✔ Mesas ilimitadas</li>
                            <li>✔ Suporte prioritário</li>
                        </ul>

                        <a
                            href="https://wa.me/5567999077564?text=Olá! Quero assinar o PLANO ANUAL do MesaClick."
                            target="_blank"
                            rel="noopener noreferrer"
                            className="plan-btn plan-btn-annual"
                        >
                            Assinar Anual
                        </a>
                    </div>

                </div>

                <div className="upgrade-actions">
                    {blocked ? (
                        <button className="upgrade-exit-btn" onClick={handleLogout}>
                            Sair da conta
                        </button>
                    ) : (
                        <button className="upgrade-exit-btn" onClick={() => navigate("/home")}>
                            Voltar ao sistema
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
}
